export enum PickRoundSpotValueType {
    Cash = <any>'cash',
    Count = <any>'count',
    Multiplier = <any>'multiplier'
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Types/PickRoundSpotValueType.ts
 **/